// extracted by mini-css-extract-plugin
export default {"root":"_2W_l3","animator":"vGlKJ","notification-link":"_1OrIx","notificationLink":"_1OrIx"};